import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuxiliarService } from './../../auxiliar.service';
import { AuthService } from './../auth/auth.service';

export interface RegistrosQueryParams {
  clasificado?: string;
  page?: number;
  pageSize?: number;
  search?: string;
  scale?: string;
  recordType?: string;
  movementType?: string;
  sort?: string;
  direction?: string;
  export?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class RegistrosService {

  server: string = '';
  token: string = '';

  constructor(private auth: AuthService, private httpClient: HttpClient, private auxiliarService: AuxiliarService) {
    this.server = this.auxiliarService.getServidor()+"/api/registros";
    this.token = this.auth.getToken();
  }

  getRegistros(clasificado: string = 'all') {
    return this.getRegistrosPaginated({ clasificado, page: 1, pageSize: 25 });
  }

  getRegistrosPaginated(params: RegistrosQueryParams) {
    const clasificado = params.clasificado ?? 'all';
    let httpParams = new HttpParams()
      .set('page', (params.page ?? 1).toString())
      .set('pageSize', (params.pageSize ?? 25).toString());
    if (params.search !== undefined) {
      httpParams = httpParams.set('search', params.search);
    }
    if (params.scale !== undefined) {
      httpParams = httpParams.set('scale', params.scale);
    }
    if (params.recordType !== undefined) {
      httpParams = httpParams.set('recordType', params.recordType);
    }
    if (params.movementType !== undefined) {
      httpParams = httpParams.set('movementType', params.movementType);
    }
    if (params.sort) {
      httpParams = httpParams.set('sort', params.sort);
    }
    if (params.direction) {
      httpParams = httpParams.set('direction', params.direction);
    }
    if (params.export) {
      httpParams = httpParams.set('export', 'true');
    }

    return this.httpClient.get<{ data: any[]; total: number }>(
      this.server + '/getall/' + clasificado,
      { params: httpParams }
    );
  }

  searchRegistros(albaran: number) {
    return this.httpClient.get(this.server+'/search/'+albaran);
  }

  getDatosRegistro(albaran: number, fotos: string = 'full') {
    return this.httpClient.get(this.server+'/datos/'+albaran+'/'+fotos);
  }

  newClasificacion(albaran: number,id_residuo: string,id_residuo_clasificado: string, peso: string, descripcion: string, foto1: any, foto2: any) {
    const formData = new FormData();
    formData.append('albaran', albaran.toString());
    formData.append('id_residuo', id_residuo);
    formData.append('id_residuo_clasificado', id_residuo_clasificado);
    formData.append('peso', peso);
    formData.append('descripcion', descripcion);
    formData.append('foto1', foto1);
    formData.append('foto2', foto2);
    return this.httpClient.post(this.server, formData);
  }

  editClasificacion(idClasificacion: number,id_residuo_clasificado: string, peso: string, descripcion: string, foto1: any, foto2: any, albaran: number, residuo: number) {
    const formData = new FormData();
    formData.append('idClasificacion', idClasificacion.toString());
    formData.append('id_residuo_clasificado', id_residuo_clasificado);
    formData.append('peso', peso);
    formData.append('descripcion', descripcion);
    formData.append('foto1', foto1);
    formData.append('foto2', foto2);
    formData.append('albaran', albaran.toString());
    formData.append('id_residuo', residuo.toString());
    return this.httpClient.post(this.server+'/editclasificacion', formData);
  }

  deleteClasificacion(idClasificacion) {
    return this.httpClient.delete(this.server+'/deleteclasificacion/'+idClasificacion);
  }

  deleteAlbaran(albaran) {
    const formData = new FormData();
    formData.append('albaran', albaran);
    return this.httpClient.post(this.server+'/deletealbaran', formData);
  }

  deletePesaje(id) {
    const formData = new FormData();
    formData.append('id', id);
    return this.httpClient.post(this.server+'/deletepesaje', formData);
  }

  editPesaje(id: number, descripcion: string, fechaFinal: string, hora: string, material: string, matricula: string, nAlbaran: string, peso: string, usuario: string ){
    const formData = new FormData();
    formData.append('id', id.toString());
    formData.append('descripcion', descripcion);
    formData.append('fechaFinal', fechaFinal);
    formData.append('hora', hora);
    formData.append('material', material);
    formData.append('matricula', matricula);
    formData.append('nAlbaran', nAlbaran);
    formData.append('peso', peso);
    formData.append('usuario', usuario);
    return this.httpClient.post(this.server+'/editpesaje', formData);
  }

  getNumImpresion(){
    return this.httpClient.get(this.server+'/getnumimpresion');
  }

  clasificarAlbaran(albaran: string, status: string) {
    const formData = new FormData();
    formData.append('albaran', albaran);
    formData.append('status', status);
    return this.httpClient.post(this.server+'/clasificaralbaran', formData);
  }
}
